module.exports = __webpack_public_path__ + "img/Restore(Button).ac178b51.svg";